import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { isEqual } from 'lodash';
import { IFilterOutput } from '../filter.interface';
import { CommonUtility } from '../../../utility/common.utility';

const initialValue: unknown = {};

@Component({
  selector: 'app-filter-keyword',
  templateUrl: './filter-keyword.component.html',
  styleUrls: ['./filter-keyword.component.scss'],
  standalone: false,
})
export class FilterKeywordComponent<T> implements OnInit, OnDestroy {
  private subscriptions: Subscription;
  private _value: T;
  @Input() public label: string;
  @Input() public field: string;
  @Input() public placeholder: string = '';
  @Input() public form: UntypedFormGroup;
  @Output() public valueChange: EventEmitter<IFilterOutput<T>>;
  public output: IFilterOutput<T>;
  public domID: string;

  @Input() public set value(val: T) {
    this._value = val;
    this.initForm(val);
    this.form.get(this.field).setValue(val, { emitEvent: false });
  }

  public constructor() {
    this.label = '';
    this.field = '';
    this._value = initialValue as T;
    this.valueChange = new EventEmitter<IFilterOutput<T>>();
    this.domID = `${CommonUtility.createUniqueDOMId()}`;
    this.subscriptions = new Subscription();
  }

  public ngOnInit(): void {
    this.initForm(initialValue as T);
    this.subscriptions.add(
      this.form
        .get(this.field)
        .valueChanges.pipe(distinctUntilChanged((prev: T, curr: T) => isEqual(prev, curr)))
        .subscribe((val: T): void => {
          this._value = val;
          this.output = { field: this.field, values: val };
          this.valueChange.emit(this.output);
        }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private initForm(val: T): void {
    if (!this.form) {
      this.form = new UntypedFormGroup({
        [this.field]: new UntypedFormControl({ value: val === initialValue ? undefined : this._value }),
      });
    } else if (val !== initialValue) {
      this.form.get(this.field).setValue(this._value, { emitEvent: false });
    }
  }
}
